export const loadDashboardPage = () => import("../pages/Dashboard");
export const loadNotificationsPage = () => import("../pages/Notifications");
export const loadProductsPage = () => import("../pages/Products");
export const loadPurchasesPage = () => import("../pages/Purchases");
export const loadInventoryPage = () => import("../pages/Inventory");
export const loadMegaPayTicketsPage = () => import("../pages/MegaPayTickets");
export const loadOfflineTerminalsPage = () => import("../pages/OfflineTerminals");
export const loadTasksPage = () => import("../pages/Tasks");
export const loadTaskDetailPage = () => import("../pages/TaskDetail");
export const loadRepairWarrantyPage = () => import("../pages/RepairWarranty");
export const loadSettingsUsersPage = () => import("../pages/SettingsUsers");
export const loadAdminAssignmentSyncPage = () => import("../pages/AdminAssignmentSync");
export const loadAdminStatusSyncPage = () => import("../pages/AdminStatusSync");
export const loadMegaPaySettingsPage = () => import("../pages/MegaPaySettings");
export const loadPartPricesPage = () => import("../pages/PartPrices");
export const loadTerminalsPage = () => import("../pages/Terminals");
export const loadAssignPartsPage = () => import("../pages/AssignParts");
export const loadMyPartsPage = () => import("../pages/MyParts");
export const loadChangeApprovalsPage = () => import("../pages/ChangeApprovals");
export const loadOldPendingPartsPage = () => import("../pages/OldPendingParts");
export const loadSoldPartsPage = () => import("../pages/SoldParts");
export const loadTerminalHealthPage = () => import("../pages/TerminalHealth");
export const loadTechnicianPerformancePage = () => import("../pages/TechnicianPerformance");
export const loadTerminalPerformancePage = () => import("../pages/TerminalPerformance");
export const loadPartsMovementReportPage = () => import("../pages/PartsMovementReport");
export const loadFleetDashboardPage = () => import("../pages/fleet/FleetDashboard");
export const loadFleetVehiclesPage = () => import("../pages/fleet/Vehicles");
export const loadFleetMyVehiclesPage = () => import("../pages/fleet/MyVehicles");
export const loadFleetAssignmentsPage = () => import("../pages/fleet/VehicleAssignments");
export const loadFleetUsageLogsPage = () => import("../pages/fleet/DailyUsageLogs");
export const loadFleetMyUsageLogsPage = () => import("../pages/fleet/MyUsageLogs");
export const loadFleetFuelRecordsPage = () => import("../pages/fleet/FuelRecords");
export const loadFleetMyFuelRecordsPage = () => import("../pages/fleet/MyFuelRecords");
export const loadFleetMaintenancePage = () => import("../pages/fleet/MaintenanceRecords");
export const loadFleetReportsPage = () => import("../pages/fleet/FleetReports");
export const loadMcoDashboardPage = () => import("../pages/mco/McoDashboard");
export const loadMcoBatchesPage = () => import("../pages/mco/McoBatches");
export const loadMcoBatchDetailPage = () => import("../pages/mco/McoBatchDetail");
export const loadMcoAssignmentsPage = () => import("../pages/mco/McoAssignments");
export const loadMcoAuditLogPage = () => import("../pages/mco/McoAuditLog");
export const loadMcoPendingAssignmentsPage = () => import("../pages/mco/McoPendingAssignments");
export const loadMcoDailyTotalsPage = () => import("../pages/mco/McoDailyTotals");
export const loadMcoTerminalsPage = () => import("../pages/mco/McoTerminals");
export const loadMcoMismatchesPage = () => import("../pages/mco/McoMismatches");
export const loadMcoSettingsPage = () => import("../pages/mco/McoSettings");
export const loadMcoSitrekReportsPage = () => import("../pages/mco/McoSitrekReports");
export const loadMcoSitrekReportDetailPage = () => import("../pages/mco/McoSitrekReportDetail");
export const loadMcoSystemPage = () => import("../pages/mco/McoSystem");
export const loadMcoTerminalDetailPage = () => import("../pages/mco/McoTerminalDetail");
export const loadPosDashboardPage = () => import("../pages/PosDashboard");
export const loadPosTicketsPage = () => import("../pages/PosTickets");
export const loadPosRepairWorkspacePage = () => import("../pages/PosRepairWorkspace");
export const loadPosProductsPage = () => import("../pages/PosProducts");
export const loadPosInventoryPage = () => import("../pages/PosInventory");
export const loadPosInventoryMovementsPage = () => import("../pages/PosInventoryMovements");
export const loadPosPurchasesPage = () => import("../pages/PosPurchases");
export const loadPosUsedPartsRegisterPage = () => import("../pages/PosUsedPartsRegister");
export const loadPosDeviceReplacementsPage = () => import("../pages/PosDeviceReplacements");
export const loadPosSerialChangeReportPage = () => import("../pages/PosSerialChangeReport");

export const ROUTE_PRELOADERS = {
    "/dashboard": loadDashboardPage,
    "/notifications": loadNotificationsPage,
    "/products": loadProductsPage,
    "/purchases": loadPurchasesPage,
    "/inventory": loadInventoryPage,
    "/megapay-tickets": loadMegaPayTicketsPage,
    "/offline-terminals": loadOfflineTerminalsPage,
    "/tasks": loadTasksPage,
    "/assign-parts": loadAssignPartsPage,
    "/my-parts": loadMyPartsPage,
    "/change-approvals": loadChangeApprovalsPage,
    "/old-pending": loadOldPendingPartsPage,
    "/sold-parts": loadSoldPartsPage,
    "/repair-warranty": loadRepairWarrantyPage,
    "/reports": loadTerminalHealthPage,
    "/technician-performance": loadTechnicianPerformancePage,
    "/terminal-performance": loadTerminalPerformancePage,
    "/parts-movement": loadPartsMovementReportPage,
    "/fleet/dashboard": loadFleetDashboardPage,
    "/fleet/vehicles": loadFleetVehiclesPage,
    "/fleet/my-vehicles": loadFleetMyVehiclesPage,
    "/fleet/assignments": loadFleetAssignmentsPage,
    "/fleet/usage-logs": loadFleetUsageLogsPage,
    "/fleet/my-usage-logs": loadFleetMyUsageLogsPage,
    "/fleet/fuel-records": loadFleetFuelRecordsPage,
    "/fleet/my-fuel-records": loadFleetMyFuelRecordsPage,
    "/fleet/maintenance": loadFleetMaintenancePage,
    "/fleet/reports": loadFleetReportsPage,
    "/mco/dashboard": loadMcoDashboardPage,
    "/mco/batches": loadMcoBatchesPage,
    "/mco/assignments": loadMcoAssignmentsPage,
    "/mco/audit": loadMcoAuditLogPage,
    "/mco/pending-assignments": loadMcoPendingAssignmentsPage,
    "/mco/daily-totals": loadMcoDailyTotalsPage,
    "/mco/terminals": loadMcoTerminalsPage,
    "/mco/mismatches": loadMcoMismatchesPage,
    "/mco/settings": loadMcoSettingsPage,
    "/mco/sitrek": loadMcoSitrekReportsPage,
    "/mco/system": loadMcoSystemPage,
    "/pos/dashboard": loadPosDashboardPage,
    "/pos/tickets": loadPosTicketsPage,
    "/pos/repairs": loadPosRepairWorkspacePage,
    "/pos/products": loadPosProductsPage,
    "/pos/inventory": loadPosInventoryPage,
    "/pos/inventory-movements": loadPosInventoryMovementsPage,
    "/pos/purchases": loadPosPurchasesPage,
    "/pos/used-parts": loadPosUsedPartsRegisterPage,
    "/pos/device-replacements": loadPosDeviceReplacementsPage,
    "/pos/serial-changes": loadPosSerialChangeReportPage,
    "/settings-users": loadSettingsUsersPage,
    "/admin/megapay-assignment-sync": loadAdminAssignmentSyncPage,
    "/admin/megapay-status-sync": loadAdminStatusSyncPage,
    "/admin/megapay-settings": loadMegaPaySettingsPage,
    "/admin/part-prices": loadPartPricesPage,
    "/terminals": loadTerminalsPage,
};

